import EcoVideo from 'eco-design/base/eco-video';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';

const DriveBills: React.FC<{ pageType: string }> = ({ pageType }) => {
    const { t } = useLang('theProduct.DriveBills');
    const { locale } = getLocal();
    const title = pageType === 'ac' && locale === 'fr' ? t('ac_title') : t('title');
    const items = [
        {
            title: t('param1_title'),
            desc: t('param1_desc'),
        },
        {
            title: pageType === 'ac' && locale === 'fr' ? t('ac_param2_title') : t('param2_title'),
            desc: t('param2_desc'),
        },
        {
            title: t('param3_title'),
            desc: t('param3_desc'),
        },
    ];
    return (
        <div className={`${styles.DriveBills} GtmModuleData-section`} data-section-id="DriveBills" data-section-title={title}>
            <EcoVideo
                autoPlay={true}
                loop={true}
                pc="https://websiteoss.ecoflow.com/upload/video/1745655970591/ac-pro.mp4"
                h5="https://websiteoss.ecoflow.com/upload/video/1745655958883/ac-pro-m.mp4"
                poster="https://websiteoss.ecoflow.com/upload/image/1745313972778/pc22%20(1).jpg"
                className="bills-video"
            />
            <div className="text-wrapper">
                <div className="h1-title">{title}</div>
                <div className="h1-desc">{t('desc')}</div>
                <div className="params">
                    {items.map((item) => {
                        return (
                            <div className="param" key={item.title}>
                                <div className="title">{item.title}</div>
                                <div className="desc">{item.desc}</div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default DriveBills;
